<script setup lang="ts">
import { onUnmounted } from 'vue';
import { useGetRef } from 'use-api-vue';

import ApiErrors from '@/ui/ApiErrors/index.vue';
import { useLogoutProvider } from '@/providers/useLogout';
import StartLogo from '@/ui/StartLogo.vue';
import type { ServerErrors } from '@/util/api/ajax/ApiResponse';

useLogoutProvider();
const { error, loading, send } = useGetRef<unknown, unknown, ServerErrors>({ onCancelCallback: onUnmounted });
send('sanctum/csrf-cookie');
</script>

<template>
  <StartLogo v-if="loading" text="Loading token..." :percent="10" />
  <div
    v-else-if="error"
    class="absolute w-full h-full flex flex-col items-center dark:bg-gray-900"
  >
    <div class="w-full max-w-sm">
      <ApiErrors :error="error" class="mt-36" />
    </div>
  </div>
  <slot v-else />
</template>
